import { render, staticRenderFns } from "./ApproverList.vue?vue&type=template&id=0b68d7ee&scoped=true"
import script from "./ApproverList.vue?vue&type=script&lang=js"
export * from "./ApproverList.vue?vue&type=script&lang=js"
import style0 from "./ApproverList.vue?vue&type=style&index=0&id=0b68d7ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b68d7ee",
  null
  
)

export default component.exports